// extracted by mini-css-extract-plugin
export default {"submission-confirmation":"SubmissionConfirmation-module__submission-confirmation--gOn8u"};